<template>
  <div class="saleBatchDetail">
    <div class="info_tip" v-if="!list.length">{{infoTip}}</div>
    <div class="part part1" v-else>
      <div class="p1-title">
        {{batch_total.supplier_name}}
        <span>{{batch_total.supplier_sn}}</span>
      </div>
      <div>批次号：{{batch_total.batch}}</div>
      <div class="p1-info">
        <span>销售额：{{batch_total.goods_total_price }}元</span>
        <!-- <span>{{list[0].type==2?"代卖":"自营"}}</span> -->
        <span class="item_type_zy" v-if="batch_total.type == 1">自营</span>
        <span class="item_type_dm" v-else>代卖</span>
      </div>
      <div class="p1-date">进货时间：{{batch_total.create_time|timeToDate}}</div>
    </div>
    <div class="part">
      <div class="part2" v-for="(item,i) in list" :key="i" @click="jumpGoodsDetail(item.goods_batch)">
        <div class="p2-title" >
          <span>{{item.goods_name}}</span>
          <van-icon name="arrow" />
        </div>
        <div class="p2-info">
          <div>
            <div>
              <div>{{item.goods_weight}}公斤</div>
              <div v-if="item.goods_bale!=3">
                <span>{{Number(item.goods_num).toFixed(2)}}</span>
                <span>{{unit_list[item.goods_bale_num-1].name}}</span>
              </div>
            </div>
            <div>销量</div>
          </div>
          <div>
            <div>{{item.goods_total_price|unitChange}}</div>
            <div>销售额({{item.goods_total_price|moneyUnit}})</div>
          </div>
          <div>
            <div>
              <div>{{Number(item.goods_total_price/item.goods_weight).toFixed(2)}}元/公斤</div>
              <div v-if="item.goods_bale!=3">{{Number(item.goods_total_price/item.goods_num).toFixed(2)}}元/{{unit_list[item.goods_bale_num-1].name}}</div>
            </div>
            <div>均价</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { batch_detail } from "@/api/work/manage/sale.js";
import {
  weightUnit,
  weightUnitChange,
  moneyUnit,
  unitChange
} from "@/utils/saleFilter.js";
export default {
  name: "saleBatchDetail",
  data() {
    return {
      list: [],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      infoTip: "加载中",
      time_star: "",
      time_end: "",
      batch_total: {
        supplier_name: "", //货主名称
        supplier_sn: "", //货主sn号
        goods_total_price: 0, //销售金额
        create_time: "", //批次进货时间
        type: 1, //类型 [1自营; 2代卖]
        batch:''//批次号
      } //
    };
  },
  filters: {
    weightUnit,
    weightUnitChange,
    moneyUnit,
    unitChange,
    // numAdd(arr) {
    //   let totalNum = arr.reduce(function(total, num) {
    //     return total + num.receivables * 1;
    //   }, 0);
    //   return (Number(totalNum).toFixed(2) + "")
    //     .split("")
    //     .reverse()
    //     .join("")
    //     .replace(/(\d{3})(?=\d)/g, "$1,")
    //     .split("")
    //     .reverse()
    //     .join("");
    // },
    numToFixed(obj) {
      if (obj.weight != 0) {
        return (obj.goods_total_price / obj.goods_weight).toFixed(2);
      } else {
        return "-";
      }
    },
    timeToDate(time) {
      let date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  },
  created() {
    let obj = {};
    obj.batch_id = this.$route.query.batch_id;
    obj.time_star = this.$route.query.time_star;
    obj.time_end = this.$route.query.time_end;
    this.time_star = this.$route.query.time_star;
    this.time_end = this.$route.query.time_end;
    this.getBatchDetail(obj);
    this.batch_total.supplier_name = this.$route.query.supplier_name;
    this.batch_total.supplier_sn = this.$route.query.supplier_sn;
    this.batch_total.goods_total_price = this.$route.query.goods_total_price;
    this.batch_total.create_time = this.$route.query.create_time;
    this.batch_total.type = this.$route.query.type;
    this.batch_total.batch = this.$route.query.batch;
    
  },
  mounted() {},
  methods: {
    // 获取数据
    getBatchDetail(batch) {
      batch_detail(batch).then(res => {
        if (res.code == 200) {
          this.list = res.data;
          this.infoTip = res.data.length ? "" : "暂无数据";
        }
      });
    },
    jumpGoodsDetail(goods_batch) {
      this.$router.push({
        path: "/manage/sale/saleGoodsDetail",
        query: {
          saleType: this.$route.query.saleType ? this.$route.query.saleType : 2,
          goods_batch,
          time_star: this.time_star,
          time_end: this.time_end
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.saleBatchDetail {
  .info_tip {
    margin-top: 0.3rem;
    text-align: center;
    font-size: 0.36rem;
    color: #999999;
  }
  .part {
    padding: 0 0.2rem;
    background-color: #fff;
    margin: 0.2rem 0;
  }
  .part1 {
    padding-top: 0.15rem;
    padding-bottom: 0.1rem;
    font-size: 0.32rem;
    .p1-title {
      line-height: 0.56rem;
      > span {
        font-size: 0.28rem;
        margin-left: 0.2rem;
      }
    }
    .p1-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // line-height: 0.51rem;
      margin-top: 0.1rem;
      margin-bottom: 0.1rem;
      > span:last-child {
        display: inline-block;
        text-align: center;
        width: 0.78rem;
        height: 0.36rem;
        border-radius: 0.18rem;
        font-size: 0.24rem;
        color: #f76900;
        background: rgba(247, 105, 0, 0.2);
        &.item_type_zy {
          background: rgba(28, 192, 233, 0.3) !important;
          color: #268ea7 !important;
        }
        &.item_type_dm {
          background: rgba(233, 153, 28, 0.3) !important;
          color: #c6601c !important;
        }
      }
    }
    .p1-date {
      font-size: 0.28rem;
      color: #818181;
      line-height: 0.47rem;
    }
  }
  .part2 {
    overflow: hidden;
    .p2-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // padding-left: 0.32rem;
      // padding-right: 0.2rem;
      font-size: 0.36rem;
      margin-top: 0.39rem;
    }
    .p2-info {
      padding-top: 0.2rem;
      padding-bottom: 0.3rem;
      display: flex;
      > div {
        width: 33.3%;
        box-sizing: border-box;
        text-align: center;
        > div:nth-of-type(1) {
          font-size: 0.32rem;
          color: #333333;
          height: 0.66rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        >div:nth-of-type(2){
          font-size: 0.28rem;
          color: #999999;
          margin-top: 0.19rem;
        }
      }
    }
  }
  .part2:not(:last-child) {
    border-bottom: 0.01rem solid #e5e5e5;
  }
}
</style>